import {createContext} from 'react';

/*
 * One context is shared by every `formBuilder()` instance, so it cannot be typed
 * to a single form's `FormContextType`. Consumers get the concrete type back
 * through `useFormContext()`, which asserts it.
 *
 * It lives in its own module so the provider file exports only components —
 * mixing a context export with components breaks Fast Refresh's ability to
 * preserve state.
 */
export const FormContext = createContext<unknown>(null);

FormContext.displayName = 'FormContext';
